export default class ValueSlider {
	constructor() {
		this.container = document.querySelector('[data-value-block]')
		if (!this.container) return

		this.buttons = this.container.querySelectorAll('[data-value-button]')
		this.contents = this.container.querySelectorAll('[data-value-content]')
		this.line = this.container.querySelector('[data-value-line]')

		if (this.buttons.length === 0) return

		this.index = 0
		this.time = 5000
		this.timeout = null

		this.#init()
	}

	#init() {
		this.#setUpTimer()
		this.#setUpClickEvents()
		this.#moveLine(this.index)
	}

	#setUpTimer() {
		this.timeout = setTimeout(() => {
			this.index = (this.index + 1) % this.buttons.length
			this.#setActive(this.index)
			this.#setUpTimer()
		}, this.time)
	}

	#setActive(index) {
		this.buttons.forEach((button, i) => {
			button.classList.toggle('active', i === index)
			button.classList.toggle('past', i < index)
		})
		this.contents.forEach((content, i) => {
			content.classList.toggle('active', i === index)
			content.classList.toggle('past', i < index)
		})
		this.#moveLine(index)
	}

	#moveLine(index) {
		if (!this.line) return
		const button = this.buttons[index]
		const containerRect = this.buttons[0].parentElement.getBoundingClientRect()
		const buttonRect = button.getBoundingClientRect()
		this.line.style.top = buttonRect.top - containerRect.top + 'px'
	}

	#setUpClickEvents() {
		this.buttons.forEach((button, i) => {
			button.addEventListener('click', () => {
				this.index = i
				this.#setActive(i)
				clearTimeout(this.timeout)
				this.#setUpTimer()
			})
		})
	}
}
